import Vue from 'vue'
import Router from 'vue-router'
// 移动端
import main from '@/components/main'
import goods from '@/components/goods/list'
import goodsDetail from '@/components/goods/detail'
import buycar from '@/components/buycar/index'
import goBuy from '@/components/buycar/goBuy'
import mine from '@/components/mine/index'
import info from '@/components/mine/info'
import order from '@/components/order/index'
import orderDetail from '@/components/order/detail'
import refund from '@/components/order/refund'
import address from '@/components/address/list'
import logistics from '@/components/logistics/index'
import customerService from '@/components/customerService/index'
import memberRecharge from '@/components/member/memberRecharge'
import memberInquiry from '@/components/member/memberInquiry'
import rechargeResult from '@/components/member/rechargeResult'

import goodsTemp from '@/components/goods/list.temp'

// pc 端商城
import mallHomepage from '@/pcComponents/main'
import mallGoods from '@/pcComponents/goods/list'
import mallGoodsDetail from '@/pcComponents/goods/goodsDetail'
import mallMine from '@/pcComponents/mine'
import mallPersonalSettings from '@/pcComponents/mine/personalSettings/index'
import shoppingCart from '@/pcComponents/shoppingCart'
import settlement from '@/pcComponents/shoppingCart/settlement'
import mallOrderDetail from '@/pcComponents/mine/orderDetail'

Vue.use(Router)

export default new Router({
  routes: [
    //正式环境功能屏蔽使用此路由
    // {
    //   path: '/goods',
    //   name: 'goodsTemp',
    //   component: goodsTemp,
    // },
    { //  会员充值
      path: '/memberRecharge',
      name: 'memberRecharge',
      component: memberRecharge,
    },
    { //  会员充值结果
      path: '/rechargeResult',
      name: 'rechargeResult',
      component: rechargeResult,
    },
    { // 会员查询
      path: '/memberInquiry',
      name: 'memberInquiry',
      component: memberInquiry,
    },
    { // pc 端首页
      path: '/mallHomepage',
      name: 'mallHomepage',
      component: mallHomepage,
      redirect: '/mallGoods',
      children: [{
        path: '/mallGoods',
        name: 'mallGoods',
        component: mallGoods
      }, {
        path: '/mallGoodsDetail',
        name: 'mallGoodsDetail',
        component: mallGoodsDetail,
      }, {
        path: '/mallMine',
        name: 'mallMine',
        component: mallMine,
      }, {
        path: '/mallPersonalSettings',
        name: 'mallPersonalSettings',
        component: mallPersonalSettings,
      }, {
        path: '/shoppingCart',
        name: 'shoppingCart',
        component: shoppingCart,
      }, {
        path: '/settlement',
        name: 'settlement',
        component: settlement,
      }, {
        path: '/mallOrderDetail',
        name: 'mallOrderDetail',
        component: mallOrderDetail,
      }]
    },
    {
      path: '/',
      name: 'main',
      component: main,
      redirect: '/goods',
      children: [{
        path: '/goods',
        name: 'goods',
        component: goods,
        meta: {
          keepAlive: true
        }
      }, {
        path: '/buycar',
        name: 'buycar',
        component: buycar
      }, {
        path: '/mine',
        name: 'mine',
        component: mine
      }]
    },
    {
      path: '/order',
      name: 'order',
      component: order,
    }, {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail,
    }, {
      path: '/refund',
      name: 'refund',
      component: refund,
    }, {
      path: '/address',
      name: 'address',
      component: address,
    }, {
      path: '/info',
      name: 'info',
      component: info,
    }, {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: goodsDetail,
    }, {
      path: '/goBuy',
      name: 'goBuy',
      component: goBuy,
    }, {
      path: '/logistics',
      name: 'logistics',
      component: logistics,
    }, {
      path: '/customer',
      name: 'customerService',
      component: customerService
    }
  ]
})



// WEBPACK FOOTER //
// ./src/config/router.js